/**
 * Icon types supported by the system
 */
export const ICON_TYPES = {
  MATERIAL: 'material',
  MATERIAL_SYMBOLS: 'material-symbols',
  LUCIDE: 'lucide',
  FONTAWESOME: 'fontawesome',
  IMAGE: 'image',
  EMOJI: 'emoji',
  SYMBOL: 'symbol'
}

export default ICON_TYPES
